import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectCoreMappingBuyers,
  selectCoreMappingDownloadError,
  selectCoreMappingIsBuyersLoading,
  selectCoreMappingIsDownloadLoading,
  selectCoreMappingIsUploadLoading,
  selectCoreMappingIsUploadSuccess,
  selectCoreMappingUploadError,
  selectCoreMappingUploadSuccessMessage,
} from '../selectors/core-mappings.selectors';

@Injectable({ providedIn: 'root' })
export class CoreMappingsSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly buyers = this._store.selectSignal(selectCoreMappingBuyers);
  public readonly isBuyersLoading = this._store.selectSignal(
    selectCoreMappingIsBuyersLoading,
  );
  public readonly isUploadLoading = this._store.selectSignal(
    selectCoreMappingIsUploadLoading,
  );
  public readonly isUploadSuccess = this._store.selectSignal(
    selectCoreMappingIsUploadSuccess,
  );
  public readonly uploadSuccessMessage = this._store.selectSignal(
    selectCoreMappingUploadSuccessMessage,
  );
  public readonly uploadError = this._store.selectSignal(
    selectCoreMappingUploadError,
  );
  public readonly isDownloadLoading = this._store.selectSignal(
    selectCoreMappingIsDownloadLoading,
  );
  public readonly downloadError = this._store.selectSignal(
    selectCoreMappingDownloadError,
  );
}
